// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__s_dV_","productName":"Table_productName__Dqqvp"};